import { cloneDeep } from "lodash";
import { getCircularSimplifyDataStructureReplacer } from "./simplifyDataStructureReplacer";
import { EncoderTypes, } from "./types";
import { any, is, mapObjIndexed, omit, propEq, values } from "ramda";
export const encodeSFUMessage = (serverURL, direction, event, payload) => ({
    timestamp: Date.now(),
    serverURL,
    direction,
    type: `${EncoderTypes.SFU_MESSAGE}/${event}`,
    payload: cloneDeep(payload),
});
export const encodeMajorEvent = (event) => ({
    timestamp: Date.now(),
    type: EncoderTypes.MAJOR_EVENT,
    payload: event,
});
export const encodeLog = (level, ...message) => ({
    timestamp: Date.now(),
    type: `${EncoderTypes.CONSOLE_MESSAGE}/${level}`,
    payload: JSON.stringify(message, getCircularSimplifyDataStructureReplacer()),
});
export const encodeWebRTCIssue = (issue) => ({
    timestamp: Date.now(),
    type: `${EncoderTypes.WEBRTC_ISSUE}/${issue.type}/${issue.reason}`,
    issueType: issue.type,
    issueReason: issue.reason,
    ssrc: issue.ssrc,
    iceCandidate: issue.iceCandidate,
    data: issue.data,
    trackIdentifier: issue.trackIdentifier,
});
export function encodeStateMachineTransition(transition) {
    const baseType = `${EncoderTypes.STATE_MACHINE_TRANSITION}/${transition.machineId}`;
    const type = transition.userId ? `${baseType}/${transition.userId}` : baseType;
    return {
        timestamp: Date.now(),
        type,
        machineId: transition.machineId,
        userId: transition.userId,
        oldState: transition.oldState,
        newState: transition.newState,
        event: transition.event,
    };
}
export const encodeMetrics = (metrics, payload) => ({
    timestamp: Date.now(),
    type: `${EncoderTypes.METRICS}/${metrics}`,
    payload: is(Object) ? cloneDeep(payload) : payload,
});
export const encodeNetworkTestResults = (payload) => {
    const actionName = any(propEq("status", "Failed"), values(payload)) ? "failed" : "passed";
    return {
        timestamp: Date.now(),
        type: `${EncoderTypes.NETWORK_TEST_RESULTS}/${actionName}`,
        payload,
    };
};
export const encodeAction = (actionName, ...message) => ({
    timestamp: Date.now(),
    type: `${EncoderTypes.ACTION}/${actionName}`,
    payload: JSON.stringify(message, getCircularSimplifyDataStructureReplacer()),
});
export const encodePlayerInfo = (currentInfo) => ({
    timestamp: Date.now(),
    type: EncoderTypes.PLAYER_INFO,
    payload: cloneDeep(mapObjIndexed((user) => omit(["_video", "_screenVideo"], user), currentInfo)),
});
export const encodeSelfInfo = (currentInfo) => ({
    timestamp: Date.now(),
    type: EncoderTypes.SELF_INFO,
    payload: cloneDeep(currentInfo),
});
export const encodeDevicesChange = (devices) => ({
    timestamp: Date.now(),
    type: EncoderTypes.DEVICES_CHANGED,
    payload: cloneDeep(devices),
});
export const encodeSelectDevice = (type, deviceId) => ({
    timestamp: Date.now(),
    type: EncoderTypes.SELECTED_DEVICE_CHANGED,
    payload: {
        deviceId: deviceId ?? null,
        type,
    },
});
export const encodeEncodingError = (error, ..._value) => ({
    timestamp: Date.now(),
    type: EncoderTypes.TRACKER_ENCODING_ERROR,
    message: error.message,
    name: error.name,
    stack: error.stack,
});
//# sourceMappingURL=encoders.js.map